import { normalizeStatus } from '../normalizers/statusNormalizers';

export const getStatusLabel = (status?: string | null): string => {
  const normalized = normalizeStatus(status);
  if (!normalized) return 'N/A';
  return normalized.replace(/^./, (character) => character.toUpperCase());
};

export const getStatusChipColor = (status?: string | null): string => {
  const normalized = normalizeStatus(status);

  if (normalized === 'processed' || normalized === 'success') return '#27C840';
  if (normalized === 'failed' || normalized === 'error') return '#FF0000';
  if (normalized === 'pending' || normalized === 'queued') return '#EDD221';
  if (normalized === 'received') return '#2C6CA0';
  if (normalized === 'ignored') return '#F59E0B';

  return '#6B7280';
};
